<template>
  <div class="d-flex flex-column">
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="top-header d-flex flex-row align-center justify-space-between">
      <div class="d-flex flex-row align-center">
        <router-link :to="{ name: 'clients_on_site_accounts' }">
          <v-btn icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </router-link>
        <span>{{ $t("CreateNewAccount") }}</span>
      </div>
    </div>

    <v-sheet class="mt-2">
      <v-form class="main-form pa-3" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('Name')"
                v-model="admin.name"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('LastName')"
                v-model="admin.lastName"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Email"
                v-model="admin.email"
                dense
                outlined
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Phone"
                v-model="admin.phone"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex flex-row align-center justify-end">
            <v-btn
              class="text-capitalize white--text"
              color="#0F52BC"
              tile
              depressed
              @click="createSupporter()"
              :loading="creating"
            >
              <img
                class="mr-1"
                width="28px"
                height="28px"
                src="/icons/plus.svg"
              />
              {{ $t("Create") }}
            </v-btn>
          </div>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceAuth from "@/api/apiAuthService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";

export default {
  name: "NewAccount",
  data() {
    return {
      creating: false,
      errorAlert: false,
      errorMsg: "",
      admin: {
        name: "",
        lastName: "",
        email: "",
        phone: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        },
        pass: v => v.length >= 8 || this.$t("errors.shortPassword")
      }
    };
  },
  computed: {
    passwordMatch() {
      return () =>
        this.admin.password === this.admin.password1 ||
        this.$t("errors.passMustMatch");
    }
  },
  methods: {
    createSupporter() {
      if (this.$refs.form.validate()) {
        this.creating = true;
        RestResourceAuth.prototype
          .addClient(this.admin)
          .then(response => {
            if (response && response.status == ResponseStatus.POST_OK) {
              this.$router.push({ name: "clients_on_site_accounts" });
            }
            this.creating = false;
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.creating = false;
          });
      }
    }
  }
};
</script>
<style></style>
